"use strict";
/* eslint-disable @typescript-eslint/no-non-null-assertion */
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Draw_js_1 = __importDefault(require("ol/interaction/Draw.js"));
const ol_1 = require("ol");
const Vector_1 = __importDefault(require("ol/source/Vector"));
const Vector_2 = __importDefault(require("ol/layer/Vector"));
const style_1 = require("ol/style");
const Circle_1 = __importDefault(require("ol/style/Circle"));
const Modify_1 = __importDefault(require("ol/interaction/Modify"));
const ol_2 = require("ol");
const geom_1 = require("ol/geom");
const format_1 = require("ol/format");
const render_1 = require("ol/render");
const BaseMapLayer_1 = __importDefault(require("../models/BaseMapLayer"));
const extent_1 = require("ol/extent");
const olSphere = __importStar(require("ol/sphere"));
const proj_1 = require("ol/proj");
class OverlayBuilder {
    constructor(map = new ol_1.Map()) {
        this.finishDrawInteraction = false;
        this.map = map;
    }
    get projections() {
        return { dataProjection: 'EPSG:4326', featureProjection: 'EPSG:3857' };
    }
    get drawStyles() {
        const pointsStyle = new Circle_1.default({
            radius: 6,
            fill: new style_1.Fill({
                color: '#eebb54',
            }),
            stroke: new style_1.Stroke({
                color: '#fff',
                width: 3,
            }),
        });
        const drawingStyle = new style_1.Style({
            fill: new style_1.Fill({
                color: '#2a734650',
            }),
            stroke: new style_1.Stroke({
                color: '#2a7346',
                width: 3,
            }),
            image: pointsStyle,
        });
        const endStyle = new style_1.Style({
            fill: new style_1.Fill({
                color: [0, 0, 0, 0],
            }),
            stroke: new style_1.Stroke({
                color: '#ffffff',
                width: 3,
            }),
            image: pointsStyle,
        });
        const endStyleStep2 = new style_1.Style({
            fill: new style_1.Fill({
                color: [0, 0, 0, 0],
            }),
            stroke: new style_1.Stroke({
                color: '#ffffff',
                width: 3,
            }),
            image: pointsStyle,
        });
        return {
            pointsStyle: pointsStyle,
            drawingStyle: drawingStyle,
            endStyle: endStyle,
            endStyleStep2: endStyleStep2,
        };
    }
    removeDrawInteraction() {
        const interactionsToRemove = [];
        // Recorrer todas las interacciones del mapa
        this.map.getInteractions().forEach(interaction => {
            // Verificar si la interacción es de tipo Draw o Modify
            if (interaction instanceof Draw_js_1.default || interaction instanceof Modify_1.default) {
                interactionsToRemove.push(interaction);
            }
        });
        // Eliminar las interacciones identificadas
        interactionsToRemove.forEach((interaction) => {
            this.map.removeInteraction(interaction);
        });
        this.map.getViewport().style.cursor = 'default';
    }
    async addDrawInteraction() {
        this.finishDrawInteraction = false;
        const polygonSource = new Vector_1.default();
        const polygonLayer = new Vector_2.default({ source: polygonSource });
        const pointsSource = new Vector_1.default();
        const pointsLayer = new Vector_2.default({
            source: pointsSource,
            style: new style_1.Style({ image: this.drawStyles.pointsStyle }),
        });
        const drawInteraction = new Draw_js_1.default({ source: polygonSource, type: 'Polygon', style: this.drawStyles.drawingStyle });
        polygonLayer.set('id', 'draw-polygon-layer');
        polygonLayer.setZIndex(3);
        pointsLayer.set('id', 'draw-points-layer');
        pointsLayer.setZIndex(3);
        this.map.addLayer(polygonLayer);
        this.map.addLayer(pointsLayer);
        this.map.addInteraction(drawInteraction);
        const modifyInteraction = new Modify_1.default({
            source: polygonSource,
            style: new style_1.Style({ image: this.drawStyles.pointsStyle }),
        });
        this.map.addInteraction(modifyInteraction);
        const addPointsToLayer = (coordinates) => {
            pointsSource.clear(); // Limpiar puntos existentes
            coordinates.forEach((coordinate) => {
                const puntoFeature = new ol_2.Feature(new geom_1.Point(coordinate));
                pointsSource.addFeature(puntoFeature);
            });
        };
        modifyInteraction.on('modifyend', (event) => {
            const feature = event.features.item(0); // El primer polígono modificado
            if (feature) {
                const geometry = feature.getGeometry();
                const coordinates = geometry.getCoordinates()[0];
                addPointsToLayer(coordinates); // Agrega los puntos actualizados
            }
        });
        modifyInteraction.on('modifystart', (event) => {
            const feature = event.features.item(0); // El primer polígono modificado
            if (feature) {
                const geometry = feature.getGeometry();
                const coordinates = geometry.getCoordinates()[0];
                coordinates.forEach((coordinate) => {
                    const puntoFeature = pointsSource.getClosestFeatureToCoordinate(coordinate);
                    if (puntoFeature) {
                        pointsSource.removeFeature(puntoFeature);
                    }
                });
            }
            this.map.getViewport().style.cursor = 'grab';
        });
        const self = this;
        drawInteraction.on('drawend', async (event) => {
            const feature = event.feature;
            feature.setStyle(this.drawStyles.endStyle);
            const geometry = feature.getGeometry();
            const coordinates = geometry.getCoordinates()[0];
            coordinates.forEach((coordinate) => {
                const puntoFeature = new ol_2.Feature(new geom_1.Point(coordinate));
                pointsSource.addFeature(puntoFeature);
            });
            drawInteraction.setActive(false);
            self.finishDrawInteraction = true;
        });
    }
    resetBaseLayer(provider, apiKey) {
        // Eliminar la capa con recorte si existe
        const layers = this.map.getLayers().getArray();
        const clippedLayer = layers.find((layer) => layer.get('id') === 'draw-basecopy-layer');
        if (clippedLayer) {
            this.map.removeLayer(clippedLayer);
        }
        // Agregar nuevamente la capa base original
        const baseLayer = new BaseMapLayer_1.default(provider, apiKey).layers;
        baseLayer.set('id', 'base-layer');
        baseLayer.setZIndex(2);
        this.map.addLayer(baseLayer);
    }
    recortarLayerConWKT(provider, apiKey, layerPolygonId) {
        const layers = this.map.getLayers().getArray();
        const baseLayerCopy = new BaseMapLayer_1.default(provider, apiKey).layers;
        /* const baselayer = new BaseMapLayer(provider, apiKey).layers;
        baselayer.setZIndex(0)
        this.map.addLayer(baselayer) */
        const polygonLayer = layers.find((layer) => layer.get('id') === layerPolygonId);
        const endStyles2 = this.drawStyles.endStyleStep2;
        polygonLayer.setStyle(endStyles2);
        const polygonSource = polygonLayer.getSource();
        const featureP = polygonSource.getFeatures();
        baseLayerCopy.set('id', 'draw-basecopy-layer');
        baseLayerCopy.setZIndex(2);
        this.map.addLayer(baseLayerCopy);
        featureP.forEach((featureT) => {
            const geometry = featureT.getGeometry();
            // Obtener la extensión de la geometría
            const extent = geometry.getExtent();
            const clipSource = new Vector_1.default({ features: [featureT] });
            const clipLayer = new Vector_2.default({ source: clipSource });
            const style = new style_1.Style({ fill: new style_1.Fill({ color: 'black' }) });
            baseLayerCopy.on('postrender', function (e) {
                const vectorContext = (0, render_1.getVectorContext)(e);
                e.context.globalCompositeOperation = 'destination-out';
                clipLayer.getSource().forEachFeature(function (feature) {
                    vectorContext.drawFeature(feature, style);
                });
                e.context.globalCompositeOperation = 'source-over';
            });
            //center(this.map, extent, 700, [100,100,100,100])
        });
    }
    trimLayerWithCrops(provider, apiKey, layerPolygonId, wktArray) {
        const layers = this.map.getLayers().getArray();
        const baseLayerCopy = new BaseMapLayer_1.default(provider, apiKey).layers;
        const polygonLayer = layers.find((layer) => layer.get('id') === layerPolygonId);
        const endStyles2 = this.drawStyles.endStyleStep2;
        polygonLayer.setStyle(endStyles2);
        const wktFormat = new format_1.WKT();
        const features = wktArray.map(wkt => {
            const geometry = wktFormat.readGeometry(wkt);
            return new ol_2.Feature({ geometry });
        });
        const clipSource = new Vector_1.default({ features });
        const clipLayer = new Vector_2.default({ source: clipSource });
        const style = new style_1.Style({ fill: new style_1.Fill({ color: 'black' }) });
        baseLayerCopy.set('id', 'draw-basecopy-layer');
        baseLayerCopy.setZIndex(2);
        this.map.addLayer(baseLayerCopy);
        baseLayerCopy.on('postrender', function (e) {
            const vectorContext = (0, render_1.getVectorContext)(e);
            e.context.globalCompositeOperation = 'destination-out';
            clipLayer.getSource().forEachFeature(function (feature) {
                vectorContext.drawFeature(feature, style);
            });
            e.context.globalCompositeOperation = 'source-over';
        });
    }
    get drawPolygonData() {
        const layers = this.map.getLayers().getArray();
        const polygonLayer = layers.find((layer) => layer.get('id') === 'draw-polygon-layer');
        if (polygonLayer && polygonLayer.getSource().getFeatures().length) {
            const feature = polygonLayer.getSource().getFeatures()[0];
            const geometry = feature.getGeometry();
            const geometryExtent = geometry.getExtent();
            const center = (0, extent_1.getCenter)(geometryExtent);
            const area = olSphere.getArea(geometry);
            const hectares = area / 10000;
            const transformedCoordinates = geometry
                .getCoordinates()
                .map((ring) => ring.map((coord) => (0, proj_1.transform)(coord, 'EPSG:3857', 'EPSG:4326')));
            const geodata = `POLYGON(${transformedCoordinates
                .map((ring) => `(${ring.map((coord) => coord.join(' ')).join(',')})`)
                .join(', ')})`;
            return {
                coordinates: center,
                hectares: hectares,
                geodata: geodata,
            };
        }
        else {
            return {
                coordinates: [],
                hectares: 0,
                geodata: '',
            };
        }
    }
}
exports.default = OverlayBuilder;
